export const BCTONG = {
  name: "바른물류연구소 주식회사",
  businessNumber: "556-81-03004",
  ceoName: "권오성",
  address: "수원시 영통구 인계로 286",

  bankName: "농협은행 (NH)",
  bankNumber: "351-1294-6116-33",
  bankAccountHolder: "바른물류연구소 주식회사",
};

export const EUNSONG = {
  bankName: "농협은행 (NH)",
  bankNumber: "355-0061-9009-13",
  bankAccountHolder: "주식회사 은송코퍼레이션",
};

export const USER_PERMISSION = [
  { label: "관리자", value: "admin", color: "orange" },
  { label: "배차 매니저", value: "partner", color: "blue" },
  { label: "영업 프리랜서", value: "freelancer", color: "violet" },
  { label: "업체", value: "user", color: "brand" },
];

export const LOAD_TYPE = [
  { label: "전체", value: "" },
  {
    label: "당상",
    title: "당일 상차",
    value: "today",
    description: "오늘 상차 화물",
    color: "orange",
  },
  {
    label: "내상",
    title: "내일 상차",
    value: "tomorrow",
    description: "내일 상차 화물",
    color: "violet",
  },
  {
    label: "월상",
    title: "월요일 상차",
    value: "monday",
    description: "월요일 상차 화물",
    color: "teal",
  },
  {
    label: "기타",
    title: "기타 상차일",
    value: "etc",
    description: "날짜 직접 입력",
    color: "dark",
  },
];

export const UNLOAD_TYPE = [
  { label: "전체", value: "" },
  {
    label: "당착",
    title: "당일 하차",
    value: "today",
    description: "오늘 하차 화물",
    color: "orange",
  },
  {
    label: "내착",
    title: "내일 하차",
    value: "tomorrow",
    description: "내일 하차 화물",
    color: "violet",
  },
  {
    label: "월착",
    title: "월요일 하차",
    value: "monday",
    description: "월요일 하차 화물",
    color: "teal",
  },
  {
    label: "기타",
    title: "기타 하차일",
    value: "etc",
    description: "날짜 직접 입력",
    color: "dark",
  },
];

export const CAR_TYPE = [
  { label: "차종 무관", value: "차종 무관", initial: "무" },
  { label: "카고", value: "카고", initial: "카" },
  { label: "윙바디", value: "윙바디", initial: "윙" },
];

export const HOURS = [
  { value: "00:00", label: "00:00" },
  { value: "00:30", label: "00:30" },
  { value: "01:00", label: "01:00" },
  { value: "01:30", label: "01:30" },
  { value: "02:00", label: "02:00" },
  { value: "02:30", label: "02:30" },
  { value: "03:00", label: "03:00" },
  { value: "03:30", label: "03:30" },
  { value: "04:00", label: "04:00" },
  { value: "04:30", label: "04:30" },
  { value: "05:00", label: "05:00" },
  { value: "05:30", label: "05:30" },
  { value: "06:00", label: "06:00" },
  { value: "06:30", label: "06:30" },
  { value: "07:00", label: "07:00" },
  { value: "07:30", label: "07:30" },
  { value: "08:00", label: "08:00" },
  { value: "08:30", label: "08:30" },
  { value: "09:00", label: "09:00" },
  { value: "09:30", label: "09:30" },
  { value: "10:00", label: "10:00" },
  { value: "10:30", label: "10:30" },
  { value: "11:00", label: "11:00" },
  { value: "11:30", label: "11:30" },
  { value: "12:00", label: "12:00" },
  { value: "12:30", label: "12:30" },
  { value: "13:00", label: "13:00" },
  { value: "13:30", label: "13:30" },
  { value: "14:00", label: "14:00" },
  { value: "14:30", label: "14:30" },
  { value: "15:00", label: "15:00" },
  { value: "15:30", label: "15:30" },
  { value: "16:00", label: "16:00" },
  { value: "16:30", label: "16:30" },
  { value: "17:00", label: "17:00" },
  { value: "17:30", label: "17:30" },
  { value: "18:00", label: "18:00" },
  { value: "18:30", label: "18:30" },
  { value: "19:00", label: "19:00" },
  { value: "19:30", label: "19:30" },
  { value: "20:00", label: "20:00" },
  { value: "20:30", label: "20:30" },
  { value: "21:00", label: "21:00" },
  { value: "21:30", label: "21:30" },
  { value: "22:00", label: "22:00" },
  { value: "22:30", label: "22:30" },
  { value: "23:00", label: "23:00" },
  { value: "23:30", label: "23:30" },
];

export const ORDER_STATUS = [
  { label: "전체", value: "" },
  { label: "배차중", value: "requested", color: "orange" },
  { label: "배차완료", value: "accounting", color: "violet" }, // 계산서 발행 전
  { label: "계산서", value: "withdraw", color: "pink" }, // 계산서 발행 완료 + 입금 전
  { label: "지급완료", value: "finished", color: "dark" },
  { label: "취소", value: "canceled", color: "gray" },
];

export const FEE_ORDER_STATUS = [
  { label: "전체", value: "" },
  { label: "배차중", value: "feeRequested", color: "orange" },
  { label: "완료", value: "feeFinished", color: "dark" },
  { label: "취소", value: "feeCanceled", color: "gray" },
];

export const CAR_WEIGHT = [
  {
    label: "다마스/라보",
    value: "c05",
    wp: 1,
    wing: 1,
    x: 1.3,
    y: 1.9,
    z: 1.2,
    ton: 0.5, // 최대 상차 중량
    cargoTon: "0.5", // 24시콜 cargoTon
    truckTypeAll: "라보", // 24시콜 truckType (전체)
    truckTypeCargo: "라보", // 24시콜 truckType (카고)
    truckTypeWing: "다마스", // 24시콜 truckType (윙바디)
  },
  {
    label: "1톤",
    value: "c10",
    wp: 1,
    wing: 1,
    x: 1.6,
    y: 2.8,
    z: 1.5,
    ton: 1.5,
    cargoTon: "1", // 24시콜 cargoTon
    truckTypeAll: "카/윙", // 24시콜 truckType (전체)
    truckTypeCargo: "카고", // 24시콜 truckType (카고)
    truckTypeWing: "윙바디", // 24시콜 truckType (윙바디)
  },
  {
    label: "1.4톤",
    value: "c20",
    wp: 1,
    wing: 1,
    x: 1.7,
    y: 3.1,
    z: 1.5,
    ton: 2.0,
    cargoTon: "1.4", // 24시콜 cargoTon
    truckTypeAll: "카/윙", // 24시콜 truckType (전체)
    truckTypeCargo: "카고", // 24시콜 truckType (카고)
    truckTypeWing: "윙바디", // 24시콜 truckType (윙바디)
  },
  {
    label: "2.5톤",
    value: "c25",
    wp: 2,
    wing: 1,
    x: 2,
    y: 4.3,
    z: 2,
    ton: 3.5,
    cargoTon: "2.5", // 24시콜 cargoTon
    truckTypeAll: "전체", // 24시콜 truckType (전체)
    truckTypeCargo: "카고", // 24시콜 truckType (카고)
    truckTypeWing: "윙바디", // 24시콜 truckType (윙바디)
  },
  {
    label: "3.5톤",
    value: "c30",
    wp: 2,
    wing: 1,
    x: 2.0,
    y: 4.6,
    z: 2.0,
    ton: 4.5,
    cargoTon: "3.5", // 24시콜 cargoTon
    truckTypeAll: "전체", // 24시콜 truckType (전체)
    truckTypeCargo: "카고", // 24시콜 truckType (카고)
    truckTypeWing: "윙바디", // 24시콜 truckType (윙바디)
  },
  {
    label: "5톤",
    value: "c39",
    wp: 2,
    wing: 1,
    x: 2.3,
    y: 6.3,
    z: 2.0,
    ton: 6.0,
    cargoTon: "5", // 24시콜 cargoTon
    truckTypeAll: "전체", // 24시콜 truckType (전체)
    truckTypeCargo: "카고", // 24시콜 truckType (카고)
    truckTypeWing: "윙바디", // 24시콜 truckType (윙바디)
  },
  {
    label: "5톤 플러스",
    value: "c40",
    wp: 2,
    wing: 1,
    x: 2.3,
    y: 7.4,
    z: 2.4,
    ton: 7.0,
    cargoTon: "5", // 24시콜 cargoTon
    truckTypeAll: "플카/플윙", // 24시콜 truckType (전체)
    truckTypeCargo: "플러스카", // 24시콜 truckType (카고)
    truckTypeWing: "플러스윙", // 24시콜 truckType (윙바디)
  },
  {
    label: "5톤 플축",
    value: "c50",
    wp: 2,
    wing: 1,
    x: 2.3,
    y: 7.4,
    z: 2.4,
    ton: 11.0,
    cargoTon: "5", // 24시콜 cargoTon
    truckTypeAll: "플축카/플축윙", // 24시콜 truckType (전체)
    truckTypeCargo: "플축카고", // 24시콜 truckType (카고)
    truckTypeWing: "플축윙", // 24시콜 truckType (윙바디)
  },
  {
    label: "5톤 초장축",
    value: "c55",
    wp: 2,
    wing: 1,
    x: 2.3,
    y: 8.3,
    z: 2.4,
    ton: 13.0,
    cargoTon: "5", // 24시콜 cargoTon
    truckTypeAll: "초장축", // 24시콜 truckType (전체)
    truckTypeCargo: "초장축", // 24시콜 truckType (카고)
    truckTypeWing: "초장축", // 24시콜 truckType (윙바디)
  },
  {
    label: "11톤",
    value: "c60",
    wp: 2,
    wing: 2,
    x: 2.3,
    y: 9.3,
    z: 2.4,
    ton: 12.5,
    cargoTon: "11", // 24시콜 cargoTon
    truckTypeAll: "전체", // 24시콜 truckType (전체)
    truckTypeCargo: "카고", // 24시콜 truckType (카고)
    truckTypeWing: "윙바디", // 24시콜 truckType (윙바디)
  },
  {
    label: "14톤",
    value: "c70",
    wp: 2,
    wing: 2,
    x: 2.3,
    y: 9.6,
    z: 2.4,
    ton: 15.4,
    cargoTon: "14", // 24시콜 cargoTon
    truckTypeAll: "전체", // 24시콜 truckType (전체)
    truckTypeCargo: "카고", // 24시콜 truckType (카고)
    truckTypeWing: "윙바디", // 24시콜 truckType (윙바디)
  },
  {
    label: "18톤",
    value: "c80",
    wp: 2,
    wing: 2,
    x: 2.3,
    y: 10.1,
    z: 2.4,
    ton: 21.0,
    cargoTon: "18", // 24시콜 cargoTon
    truckTypeAll: "전체", // 24시콜 truckType (전체)
    truckTypeCargo: "카고", // 24시콜 truckType (카고)
    truckTypeWing: "윙바디", // 24시콜 truckType (윙바디)
  },
  {
    label: "25톤",
    value: "c90",
    wp: 2,
    wing: 2,
    x: 2.3,
    y: 10.1,
    z: 2.4,
    ton: 27.0,
    cargoTon: "25", // 24시콜 cargoTon
    truckTypeAll: "전체", // 24시콜 truckType (전체)
    truckTypeCargo: "카고", // 24시콜 truckType (카고)
    truckTypeWing: "윙바디", // 24시콜 truckType (윙바디)
  },
];

export const REGIONS = [
  { label: "성남", value: "성남시", lat: 37.4199323570328, lng: 127.12629039752 },
  { label: "안산", value: "안산시", lat: 37.3219085506387, lng: 126.830834434401 },
  { label: "평택", value: "평택시", lat: 36.992260674533, lng: 127.112688386546 },
  { label: "파주", value: "파주시", lat: 37.7600341767362, lng: 126.779876851965 },
  { label: "인천", value: "인천시", lat: 37.4560044656444, lng: 126.705258070068 },
  { label: "인천공항", value: "인천공항", lat: 37.4494502813442, lng: 126.45042670237 },
  { label: "여주", value: "여주시", lat: 37.2984233734535, lng: 127.637058787484 },
  { label: "음성", value: "음성군", lat: 36.9403218849117, lng: 127.690480041094 },
  { label: "충주", value: "충주시", lat: 36.9910490160218, lng: 127.925961035784 },
  { label: "제천", value: "제천시", lat: 37.1326577745507, lng: 128.19098500203 },
  { label: "천안", value: "천안시", lat: 36.8150678816283, lng: 127.113911972591 },
  { label: "아산", value: "아산시", lat: 36.7899741676055, lng: 127.002509638233 },
  { label: "당진", value: "당진시", lat: 36.8896748628647, lng: 126.645888436838 },
  { label: "서산", value: "서산시", lat: 36.7848762954282, lng: 126.450333937447 },
  { label: "논산", value: "논산시", lat: 36.1871836043033, lng: 127.098734690891 },
  { label: "보령", value: "보령시", lat: 36.3333366887905, lng: 126.612759338779 },
  { label: "대전", value: "대전시", lat: 36.3505388992836, lng: 127.38483484675 },
  { label: "전주", value: "전주시", lat: 35.8240731508775, lng: 127.148143800621 },
  { label: "군산", value: "군산시", lat: 35.9674665619218, lng: 126.736840487468 },
  { label: "김제", value: "김제시", lat: 35.8035816671869, lng: 126.88064623757 },
  { label: "정읍", value: "정읍시", lat: 35.5698780259932, lng: 126.856005647439 },
  { label: "광주광역시", value: "광주광역시", lat: 35.1601037626662, lng: 126.851629955742 },
  { label: "목포", value: "목포시", lat: 34.8118309400519, lng: 126.392235351241 },
  { label: "순천", value: "순천시", lat: 34.9506097806669, lng: 127.487382934915 },
  { label: "여수", value: "여수시", lat: 34.7604010648246, lng: 127.662331251572 },
  { label: "구미", value: "구미시", lat: 36.1195708487143, lng: 128.344246361062 },
  { label: "대구", value: "대구시", lat: 35.8713802646197, lng: 128.601805491072 },
  { label: "경주", value: "경주시", lat: 35.8562184605051, lng: 129.22478171309 },
  { label: "포항", value: "포항시", lat: 36.0189954294771, lng: 129.343164578825 },
  { label: "진주", value: "진주시", lat: 35.1802228341536, lng: 128.107706335688 },
  { label: "창원", value: "창원시", lat: 35.2279398139953, lng: 128.681834075638 },
  { label: "부산", value: "부산시", lat: 35.1798200522868, lng: 129.075087492149 },
  { label: "울산", value: "울산시", lat: 35.5395955247058, lng: 129.311603446508 },
  { label: "사천", value: "사천시", lat: 35.0036771766938, lng: 128.064212593324 },
  { label: "원주", value: "원주시", lat: 37.3420475880603, lng: 127.92009712318 },
  { label: "강릉", value: "강릉시", lat: 37.7521116823526, lng: 128.875906235799 },
  { label: "속초", value: "속초시", lat: 38.20689433526, lng: 128.591938589225 },
];

export const BANK_LIST = [
  { label: "농협", value: "011" },
  { label: "국민", value: "004" },
  { label: "신한", value: "088" },
  { label: "우리", value: "020" },
  { label: "기업", value: "003" },
  { label: "KEB하나", value: "081" },
  { label: "우체국", value: "071" },
  { label: "카카오뱅크", value: "090" },
  { label: "아이엠", value: "031" },
  { label: "대구", value: "031" },
  { label: "경남", value: "039" },
  { label: "부산", value: "032" },
  { label: "새마을금고", value: "045" },
  { label: "SC제일", value: "023" },
  { label: "신협", value: "048" },
  { label: "토스뱅크", value: "092" },
  { label: "케이뱅크(K뱅크)", value: "089" },
  { label: "지역농축협", value: "012" },
  { label: "광주", value: "034" },
  { label: "산림조합", value: "064" },
  { label: "산업", value: "002" },
  { label: "상호저축", value: "050" },
  { label: "수협", value: "007" },
  { label: "씨티", value: "027" },
  { label: "전북", value: "037" },
  { label: "제주", value: "035" },
  { label: "도이치", value: "055" },
  { label: "중국공상", value: "062" },
  { label: "BOA", value: "060" },
  { label: "HSBC", value: "054" },
  { label: "JP모간", value: "057" },
  { label: "비앤피파리바", value: "061" },
  { label: "교보", value: "261" },
  { label: "대신", value: "267" },
  { label: "동부", value: "279" },
  { label: "메리츠", value: "287" },
  { label: "미래에셋대우", value: "238" },
  { label: "부국", value: "290" },
  { label: "삼성", value: "240" },
  { label: "신영", value: "291" },
  { label: "신한금융투자", value: "278" },
  { label: "아이엠투자", value: "268" },
  { label: "유안타투자", value: "209" },
  { label: "유진투자", value: "280" },
  { label: "이베스트투자", value: "265" },
  { label: "키움", value: "264" },
  { label: "하나대투", value: "270" },
  { label: "하이투자", value: "262" },
  { label: "한국투자", value: "243" },
  { label: "한화투자", value: "269" },
  { label: "현대", value: "218" },
  { label: "HMC투자", value: "263" },
  { label: "KB투자", value: "226" },
  { label: "LIG투자", value: "292" },
  { label: "NH투자", value: "247" },
  { label: "SK", value: "266" },
  { label: "펀드온라인코리아", value: "294" },
];

// 100	임시저장	공급자가 작성한 세금계산서를 임시저장 합니다.
// 300	발행완료	공급자가 임시저장[100] 상태 세금계산서를 발행(전자서명) 합니다.
// 301	전송전
// 302	전송대기
// 303	전송중
// 304	전송성공	전자세금계산서 국세청 전송이 정상적으로 완료됩니다.
// 305	전송실패	전자세금계산서 국세청 전송이 특정 사유에 의하여 실패됩니다.
// 600	발행취소	공급자가 발행완료[300] 상태 전자세금계산서를 취소합니다.
// └ 발행취소[600] 전자세금계산서는 국세청 전송에서 제외됩니다.
export const POPBILL_STATUS = [
  { label: "임시저장", value: 100, color: "orange" },
  { label: "발행완료", value: 300, color: "violet" },
  { label: "전송전", value: 301, color: "gray" },
  { label: "전송대기", value: 302, color: "gray" },
  { label: "전송중", value: 303, color: "gray" },
  { label: "전송성공", value: 304, color: "brand" },
  { label: "전송실패", value: 305, color: "red" },
  { label: "발행취소", value: 600, color: "dark" },
];

export const INCOMING_TAX_STATUS = [
  { label: "수신", value: "pending", color: "orange" },
  { label: "자동", value: "automatch", color: "violet" },
  { label: "검증", value: "review", color: "red" },
  { label: "완료", value: "approved", color: "teal" },
  { label: "거절", value: "declined", color: "gray" },
];

export const INCOMING_TAX_FAIL_REASON = [
  { label: "오더없음", value: "NO_ORDER" },
  { label: "오더선택", value: "MULTIPLE_ORDERS" },
  { label: "산재제외", value: "TAX_ISSUE" },
  { label: "은행없음", value: "NO_BANK_INFO" },
];

export const CALL_ORDER_STATUS = [
  { label: "연동", value: "연동", color: "cyan" },
  { label: "접수", value: "접수", color: "orange" },
  { label: "완료", value: "완료", color: "teal" },
  { label: "자동", value: "자동", color: "teal" },
  { label: "취소", value: "취소", color: "red" },
];

// 카톡 요청 분석을 사용할 수 있는 거래처 (관리자 외 추가 허용)
export const KAKAO_PARSE_COMPANY_IDS = [83];
